<template>
    <div class="change-modal-gift-voucher">
        <h4 class="change-modal-gift-voucher__name">
            {{ voucherName }}
        </h4>

        <div v-if="voucher.recipient"
             class="change-modal-gift-voucher__recipient">
            {{ voucher.recipient.name }}
        </div>

        <div v-if="voucher.recipientMessage"
             class="change-modal-gift-voucher__message">
            {{ voucher.recipientMessage }}
        </div>

        <code class="change-modal-gift-voucher__ref">{{ voucherRef }}</code>
    </div>
</template>

<script>
import presentSoldGiftVoucherNameFilter from '@/filters/presentSoldGiftVoucherName';
import presentSoldGiftVoucherRefFilter from '@/filters/presentSoldGiftVoucherRef';
import { currencyFilter } from '@/vue/filters/currencyFilter';

export default {
    props: {
        voucher: {
            type: Object,
            required: true,
        },
    },

    computed: {
        /**
         * @return {string}
         */
        voucherName() {
            return presentSoldGiftVoucherNameFilter(currencyFilter)(this.voucher);
        },

        /**
         * @return {string}
         */
        voucherRef() {
            return presentSoldGiftVoucherRefFilter(this.voucher.ref);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/variables.less";

.change-modal-gift-voucher {
    border-radius: @border-radius-base;
    padding: @half-gutter-width;
    background: rgba(255, 255, 255, .3);
    font-size: @font-size-small;
    margin-top: @half-gutter-width;

    &__name {
        font-weight: bold;
        font-size: @font-size-base;
        margin: 0 0 5px 0;
    }

    &__recipient {
        font-weight: bold;
        margin: 5px 0;
    }

    &__message {
        font-size: @font-size-small;
        font-style: italic;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 5px 0;
    }

    &__ref {
        display: block;
        width: auto;
        font-size: @font-size-large;
        margin-top: 5px;
        user-select: text; // Make the text selectable to copy.
    }
}
</style>
